/**
 * De database is even weg. Dat is geen uitlogging, dus hoort hier ook geen
 * inlogformulier te staan: een regel die zegt wat er aan de hand is, en de
 * mededeling dat het scherm het vanzelf opnieuw probeert.
 */
import { foutBericht } from '@/lib/api/client';

type StoringProps = {
  fout: unknown;
  bezig: boolean;
  opnieuw: () => void;
};

export function Storing({ fout, bezig, opnieuw }: StoringProps) {
  return (
    <div className="flex h-full items-center justify-center bg-paper px-6">
      <div className="w-[320px]">
        <h1 className="kop text-[20px]">MamiMap</h1>
        <div className="mt-3 mb-4 h-px bg-line-strong" />
        <p className="text-[13px] text-ink-soft">{foutBericht(fout)}</p>
        <p className="mt-1.5 text-[12px] text-muted">
          Dit is geen uitlogging. Het scherm probeert het elke vijf seconden opnieuw en gaat vanzelf
          verder zodra de database er weer is.
        </p>
        <button type="button" className="knop-stil mt-4" onClick={opnieuw} disabled={bezig}>
          {bezig ? 'Bezig' : 'Nu opnieuw proberen'}
        </button>
      </div>
    </div>
  );
}
